import BaseOverlay from './base-overlay.js';

class SideDrawer extends BaseOverlay {
    constructor() {
        super();
        this.onDetailsToggle = this.handleDetailsToggle.bind(this);
    }

    init() {
        super.init();
        this.addToggleListener();
    }

    addToggleListener() {
        this.innerEl = this.querySelector('.drawer__inner');

        if (this.innerEl) {
            this.querySelectorAll('details').forEach((details) => {
                details.addEventListener('toggle', this.onDetailsToggle);
            });
        }
    }

    handleDetailsToggle(event) {
        const details = event.target;
        const detailsRect = details.getBoundingClientRect();
        const containerRect = this.innerEl.getBoundingClientRect();
        const scrollBottom = detailsRect.bottom - containerRect.bottom + this.innerEl.scrollTop + 10;
        if (scrollBottom > 0) {
            this.innerEl.scrollTo({
                top: scrollBottom,
                behavior: 'smooth'
            });
        }
    }

    getContentElement() {
        return this.querySelector('.drawer__inner');
    }

    destroy() {
        super.destroy();

        if (this.innerEl) {
            this.querySelectorAll('details').forEach((details) => {
                details.removeEventListener('toggle', this.onDetailsToggle);
            });
        }
    }
}

customElements.define('side-drawer', SideDrawer);
